import { useState } from "react";
import PricingCard from "../Card/PricingCard";

const Pricing1 = () => {

    const [isActive, setIsActive] = useState('monthly');

    return (
        <section className="pricing-section section-padding pt-0 fix">
        <div className="container">
            <div className="section-title text-center mxw-685 mx-auto">
                <div className="subtitle">
                    Nossos Preços <img src="/assets/images/icon/fireIcon.svg" alt="icon" />
                </div>
                <h2 className="title">Plano Simples e Transparente!</h2>
                <p className="text">Taxa fixa sem surpresas. Comece a vender hoje mesmo com saque no mesmo dia (D+0) e todas as ferramentas que você precisa.
                </p>
            </div>
            <div className="pricing-wrapper style1">
                <div className="tab-section d-flex justify-content-center align-items-center">

                </div>
                <div className="tab-content" id="pills-tabContent">
                    <div className={`tab-pane ${isActive === 'monthly' ? 'active' : ''}`} id="pills-monthly" role="tabpanel"
                        aria-labelledby="pills-monthly-tab">
                        <div className="row gy-5 justify-content-center">

                            <PricingCard
                                name="Taxa Especial de Lançamento"
                                price="6,99%"
                                monthly="+ R$1,49 por transação"
                                content="Tudo que você precisa para vender online com saque instantâneo e ferramentas completas de vendas."
                                FeatureList={[
                                    "Saque Instantâneo (D+0)",
                                    "Checkout Personalizado",
                                    "Quiz Interativo com Checkout",
                                    "API PIX para Pagamentos",
                                    "Área de Membros Completa",
                                ]} 
                                btnname="Começar a Vender Agora"
                                btnurl="https://app.hubgate.com.br/register"
                            ></PricingCard>

                            

                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </section>
    );
};

export default Pricing1;